__turbopack_context__.v({
  "actions": "-29PrW_actions",
  "card": "-29PrW_card",
  "cardDescription": "-29PrW_cardDescription",
  "cardIcon": "-29PrW_cardIcon",
  "cardSelected": "-29PrW_cardSelected",
  "cardTitle": "-29PrW_cardTitle",
  "cards": "-29PrW_cards",
  "container": "-29PrW_container",
  "infoButton": "-29PrW_infoButton",
  "label": "-29PrW_label",
  "tooltip": "-29PrW_tooltip",
});
